<script lang="ts">
	import { onDestroy } from "svelte";
	import { formObjectStores } from "../../stores/stores.searchform";
	import { serpPageConfigStores } from "../../stores/stores.serpPage";
	import { totalItemsStores, currentPageStores } from "../../stores/stores.filters";
	import { msg } from "../../modules/utils.serpPage";
	import { Icon } from "../../../generic/components";

	let totalPage: number = 0;
	let limit: number = $serpPageConfigStores.limitFilter ?? 12;
	let totalItems: number = 0;
	let currentPage: number = 1;

	$: showPrevBtn = currentPage > 1;
	$: showNextBtn = currentPage < totalPage;

	const totalItemsStoresUnsubscribe = totalItemsStores.subscribe(val => {
		currentPage = 1;
		totalItems = val;
		totalPage = Math.ceil(totalItems / limit);
	});

	const formObjectStoresUnsubscribe = formObjectStores.subscribe(data => {
		limit = data.limit;
		currentPage = (data.page) ? data.page : 1;
	});

	const currentPageStoresUnsubscribe = currentPageStores.subscribe(val => {
		if (val > 0) {
			currentPage = val;
		}
		checkCorrectChangedPage();
	});

	function changeOptions() {
		checkCorrectChangedPage();
		formObjectStores.update(form => {
			const startPage = currentPage * limit - limit;
			form.offset = startPage < 0 ? 0 : startPage;
			form.page = currentPage;
			return form;
		});
		currentPageStores.set(currentPage);
	}

	function nextPage() {
		currentPage++;
		changeOptions();
	}

	function prevPage() {
		currentPage--;
		changeOptions();
	}

	function checkCorrectChangedPage() {
		if (currentPage < 1) {
			currentPage = 1;
		}
		if (currentPage > totalPage) {
			currentPage = totalPage;
		}
	}

	onDestroy(() => {
		totalItemsStoresUnsubscribe();
		formObjectStoresUnsubscribe();
		currentPageStoresUnsubscribe();
	});
</script>

<div class="pagination">
	<div class="inputWrapper">
		{#if showPrevBtn}
			<button type="button" class="btnIcon" on:click={prevPage} title="">
				<Icon template="ic-carret-left" height="1rem" width="1rem" />
			</button>
		{/if}
		<input type="number" disabled={totalPage === 1} class="controlFreeNumberInput" min="1" step="1" bind:value={currentPage} on:change={changeOptions} max={totalPage} />
		{msg("from")}
		{totalPage}
		{#if showNextBtn}
			<button type="button" class="btnIcon" on:click={nextPage} title="">
				<Icon template="ic-carret-right" height="1rem" width="1rem" />
			</button>
		{/if}
	</div>
</div>
